import { boolean, object, string } from "yup";

export const addressLookupSchema = object({
  placeId: string()
    .defined()
    .test("address-valid", function (value) {
      if (this.parent.invalid) return this.createError({ message: "L'adresse est invalide" });
      if (!value) return this.createError({ message: "L'adresse est requise" });
      return true;
    }),
  description: string().required(),
  sessionToken: string().defined(),
  invalid: boolean().required(),
});

export const optionalAddressLookupSchema = object({
  placeId: string()
    .defined()
    .test("address-valid", function () {
      if (this.parent.invalid) return this.createError({ message: "L'adresse est invalide" });
      return true;
    }),
  description: string().defined(),
  sessionToken: string().defined(),
  invalid: boolean().required(),
});

// L'API désigne postalAddress ; le formulaire porte l'erreur d'adresse sur placeId, sous la recherche Google
export const POSTAL_ADDRESS_FIELD_RENAMES = { postalAddress: "postalAddress.placeId" } as const;
